<template>
  <div>
    <div v-if="lockedOnSubmission" class="form-actions">
      {{ lang.get('entries.messages.submitted') }}
    </div>
    <div v-else-if="awaitingPayment" class="form-actions">
      {{ lang.get('entries.messages.awaiting-payment') }}
    </div>
    <div v-else-if="readOnly" class="form-actions">
      <span class="btn btn-primary btn-lg disabled">{{
        lang.get('buttons.saveNext')
      }}</span>
      <span class="btn btn-primary btn-lg disabled">{{
        lang.get('buttons.saveClose')
      }}</span>
      <preview-link />
      <span class="entries-closed">{{
        lang.get('entries.messages.closed')
      }}</span>
    </div>
    <div v-else class="form-actions">
      <div v-if="prepaymentRequired">
        <pay-button />
        <cancel-button />
      </div>
      <div v-else>
        <save-button v-if="showSubmitOnFirstTab" />
        <save-next-button v-else />
        <save-close-button />
        <preview-button />
        <submit-button />
      </div>
      <status />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CancelButton from './CancelButton';
import PreviewButton from './PreviewButton';
import PreviewLink from './PreviewLink';
import SaveButton from './SaveButton';
import SaveCloseButton from './SaveCloseButton';
import SaveNextButton from './SaveNextButton';
import SubmitButton from './SubmitButton';
import PayButton from './PayButton';
import Status from './Status';

export default {
  inject: ['lang'],
  components: {
    CancelButton,
    PreviewButton,
    PreviewLink,
    SaveButton,
    SaveCloseButton,
    SaveNextButton,
    SubmitButton,
    PayButton,
    Status
  },
  computed: {
    showSubmitOnFirstTab() {
      return !this.prepaymentRequired && !this.hasMultipleTabs;
    },
    prepaymentRequired() {
      return this.prepaymentWasRequired && !this.isManager;
    },
    ...mapState('entryForm', ['entry', 'isManager']),
    ...mapState('entryFormButtons', [
      'awaitingPayment',
      'lockedOnSubmission',
      'readOnly'
    ]),
    ...mapState('entryFormButtons', {
      prepaymentWasRequired: 'prepaymentRequired'
    }),
    ...mapGetters('entryForm', ['hasMultipleTabs']),
    showSubmittedMessage() {
      return this.entry.submittedAt && !this.entry.resubmissionRequired;
    }
  }
};
</script>
